import { Link } from 'react-router-dom';

const features = [
  {
    id: 'bullion',
    title: 'Bullion Emblem',
    titleKo: '불리온 엠블럼',
    description:
      '순금 및 은 와이어로 정교하게 제작된 불리온 엠블럼. 군사·예복·기업 배지 등 최고급 엠블럼을 맞춤 제작합니다.',
    icon: 'ri-medal-line',
    bg: '#2C2C2C',
  },
  {
    id: 'handmade',
    title: 'Handmade Embroidery',
    titleKo: '핸드메이드 자수',
    description:
      '장인의 손으로 한 땀 한 땀 완성하는 핸드메이드 자수. 실크·금사·은사 등 고급 소재로 섬세함의 극치를 선보입니다.',
    icon: 'ri-scissors-line',
    bg: '#1A1A1A',
  },
  {
    id: 'custom',
    title: 'Custom Orders',
    titleKo: '맞춤 제작',
    description:
      '고객의 아이디어를 현실로 구현하는 맞춤 제작 서비스. 로고, 패턴, 문장 등 어떤 디자인도 완벽하게 재현합니다.',
    icon: 'ri-pencil-ruler-line',
    bg: '#252525',
  },
];

export default function EmbroiderySection() {
  return (
    <section className="bg-cream py-28 px-16">
      <div className="max-w-[1300px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-gold text-[10px] tracking-[0.3em] uppercase font-sans mb-5">
            Our Expertise
          </p>
          <h2 className="font-serif text-charcoal text-5xl font-light tracking-wide">
            전문 분야
          </h2>
          <div className="flex items-center justify-center gap-4 mt-6">
            <div className="w-12 h-px bg-gold/50" />
            <div className="w-1.5 h-1.5 rounded-full bg-gold/60" />
            <div className="w-12 h-px bg-gold/50" />
          </div>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.id}
              className="group relative overflow-hidden"
              style={{ backgroundColor: f.bg }}
            >
              {/* Gold top accent */}
              <div className="h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />

              <div className="p-10">
                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center border border-gold/30 mb-8">
                  <i className={`${f.icon} text-gold text-base`} />
                </div>

                {/* Title */}
                <h3 className="font-serif text-cream text-2xl font-light mb-2 tracking-wide">
                  {f.title}
                </h3>
                <p className="text-gold text-[10px] tracking-[0.2em] uppercase font-sans mb-6">
                  {f.titleKo}
                </p>

                {/* Description */}
                <p className="text-cream/45 text-xs leading-7 font-sans font-light mb-8">
                  {f.description}
                </p>

                {/* Link */}
                <Link
                  to="/embroidery"
                  className="inline-flex items-center gap-2 text-gold/70 text-[10px] tracking-[0.18em] uppercase font-sans group-hover:text-gold transition-colors duration-200 cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line text-xs transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
              </div>

              {/* Bottom gold line hover effect */}
              <div className="absolute bottom-0 left-0 right-0 h-px bg-gold/0 group-hover:bg-gold/40 transition-all duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
